module.exports = __webpack_public_path__ + "static/media/reciborechazado.53d619fe.png";